import React, { useState, useEffect } from "react";
import { Input, Label, Form } from "semantic-ui-react"; // Grid, Button,
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { loginUser } from "../../actions/authActions";
import LogInModal from "./LogInModal";

import compassHoldingLogo from "../../assets/CompassHoldingLogo.png";
import Img0 from "../../assets/Compass-Lease-1920x1080-0.png";
import Img1 from "../../assets/Compass-Lease-1920x1080-1.png";
import Img2 from "../../assets/Compass-Lease-1920x1080-2.png";
import Img3 from "../../assets/Compass-Lease-1920x1080-3.png";
import Img4 from "../../assets/Compass-Lease-1920x1080-5.png";
import Img5 from "../../assets/Compass-Lease-1920x1080-6.png";
import Img6 from "../../assets/Compass-Lease-1920x1080-7.png";
import Img7 from "../../assets/Compass-Lease-1920x1080-8.png";
import Img8 from "../../assets/CIG-1920x1080-5.png";
import Img9 from "../../assets/CPS-1920x1080-5.png";
import Img10 from "../../assets/SmartBoard-1920x1080-5.png";
import Img11 from "../../assets/Compass-Lease-1920x1080-10.png";

import "./logInForm.css";
import "../homePage/homePage.css";

function LogInForm(props) {
  const [userData, setUserData] = useState({
    email: "",
    password: ""
  });
  const { auth, error, history, loginUser } = props;
  
  let backgroungIndex = 0;

  useEffect(() => {
    if (auth.isAuthenticated) {
      history.push("/");
    }
  }, [auth.isAuthenticated]);

  useEffect(() => {
    backgroundSlider();
  }, []);

  const setUser = event => {
    setUserData({
      ...userData,
      [event.target.name]: event.target.value
    });
  };

  const sendLoginRequest = () => {
    loginUser(userData);
  };

  const backgroundSlider = () => {
    let i;
    let images = document.getElementsByClassName("backgroundImg");
    for (i = 0; i < images.length; i++) {
      images[i].style.display = "none";  
    }
    backgroungIndex++;
    if (backgroungIndex > images.length) {
      backgroungIndex = 1
    }    
    for (i = 0; i < images.length; i++) {
      if (images[i]){
        images[i].className = images[i].className.replace(" active", "");
        images[backgroungIndex-1].style.display = "flex";  
        images[backgroungIndex-1].className += " active";
      } 
    }
    
    setTimeout(backgroundSlider, 7000);
  }

  const openLink = link => {
    window.open(link, "_blank");
  }

  return (
    <div style={{ height: "100vh" }}>
      <div className="wrapper fadeInDown" style={{ paddingRight: 0, paddingLeft: 0, height: "100%" }}>
      <div className="backgroundImg fade">
          <img src={Img0} alt="backgroundNo-0" onClick={e => openLink("https://smartboardtms.com/imgs/Yasminka/ctc.MP4")}/>
        </div> 
        <div className="backgroundImg fade">
          <img src={Img1} alt="backgroundNo-1"/>
        </div>  
        <div className="backgroundImg fade">
          <img src={Img2} alt="backgroundNo-2"/>
        </div> 
        <div className="backgroundImg fade">
          <img src={Img3} alt="backgroundNo-3"/>
        </div> 
        <div className="backgroundImg fade">
          <img src={Img4} alt="backgroundNo-4"/>
        </div> 
        <div className="backgroundImg fade">
          <img src={Img5} alt="backgroundNo-5"/>
        </div> 
        <div className="backgroundImg fade" onClick={e => openLink("https://smartboardtms.com/")}>
          <img src={Img6} alt="backgroundNo-6"/>
        </div> 
        <div className="backgroundImg fade" onClick={e => openLink("https://smartboardtms.com/")}>
          <img src={Img7} alt="backgroundNo-7"/>
        </div> 
        <div className="backgroundImg fade" onClick={e => openLink("https://smartboardtms.com/")}>
          <img src={Img8} alt="backgroundNo-8"/>
        </div> 
        <div className="backgroundImg fade" onClick={e => openLink("https://www.compassarena.com/")}>
          <img src={Img9} alt="backgroundNo-9"/>
        </div> 
        <div className="backgroundImg fade">
          <img src={Img10} alt="backgroundNo-10"/>
        </div> 
        <div className="backgroundImg fade">
          <img src={Img11} alt="backgroundNo-10"/>
        </div> 
        <div id="formContent">
          {/* Welcome */}
          <h2 className="active"> Welcome to </h2>

          {/* Icon */}
          <div className="fadeIn first">
            <img
              src={compassHoldingLogo}
              id="icon"
              alt="User Icon"
              style={{ marginBottom: "10px" }}
            />
          </div>

          {/* Login Form */}
          <Form onSubmit={sendLoginRequest}>
            <Input
              icon="envelope"
              iconPosition="left"
              type="text"
              id="login"
              className="fadeIn second"
              name="email"
              placeholder="email"
              onChange={setUser}
              size="small"
              style={{ marginLeft: "35px", width: "250px" }}
            />
            {error.email ? (
              <Label basic color="red">
                {error.email}
              </Label>
            ) : (
              <Label
                basic
                color="red"
                style={{ visibility: "hidden", marginBottom: "8px" }}
              >
                {error.email}
              </Label>
            )}
            <Input
              icon="lock"
              iconPosition="left"
              type="password"
              id="password"
              className="fadeIn third"
              name="password"
              placeholder="password"
              onChange={setUser}
              size="small"
              style={{
                marginLeft: "9px",
                marginRight: "0px",
                marginTop: "5px",
                width: "250px"
              }}
            />
            {error.password && (
              <Label basic color="red">
                {error.password}
              </Label>
            )}
            <input
              type="submit"
              className="fadeIn fourth"
              value="Log In"
              style={{ marginLeft: "30px" }}
            />
          </Form>

          {/* Remind Password */}
          <div id="formFooter">
            <LogInModal />
          </div>
        </div>
      </div>
    </div>
  );
}

LogInForm.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.object
    // PropTypes.instanceOf
  ]),
  error: PropTypes.PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.bool,
      PropTypes.number,
      PropTypes.instanceOf,
      PropTypes.object
    ])
  ),
  history: PropTypes.PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object,
      PropTypes.string,
      PropTypes.number,
      PropTypes.func
    ])
  ).isRequired
};

LogInForm.defaultProps = {
  auth: {},
  error: {
    user: {}
  }
};

const mapStateToProps = state => ({
  auth: state.auth,
  error: state.error
});

const mapDispatchToProps = dispatch => {
  return {
    loginUser: data => dispatch(loginUser(data))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LogInForm)
);
